export default __webpack_public_path__ + "static/media/cf-top.4a0621a8.PNG";